<div class="relative">
  <input [disabled]="disabled || paramValue == 'true'" (keypress)="validateInput($event)" [attr.maxlength]="type === 'hhmmss' ? 8 : (type_total_latter > 0 ? type_total_latter : null)" [(ngModel)]="value" (ngModelChange)="onChange($event)" [type]="(text_type && mask) ? 'password' : 'text'" [ngClass]="{
      'rounded-full': rounded,
      'rounded-lg': !rounded,
      'bg-gray-50': disabled,
      'bg-white': !disabled
    }" [id]="label" class="block p-4 w-full text-sm text-gray-900 bg-white border border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer" [placeholder]="placeholder || (type === 'hhmmss' ? 'HH:MM:SS' : '')" />

  <label [for]="label" class="pointer-events-none left-2 absolute text-sm text-[#666666] duration-300 transform -translate-y-4 scale-75 top-2 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-900 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 truncate">
    {{label}}<span *ngIf="is_required" class="col-span-2 text-red-700 text-opacity-60">*</span>
  </label>

  <button *ngIf="fetch" (click)="fetch_clicked()" class="text-blue-500 text-sm absolute font-medium right-4 top-3">Fetch</button>

  <button *ngIf="copyable" (click)="copy_clicked()" class="text-gray-600 text-sm absolute right-2 top-[10px] active:bg-gray-50 hover:bg-gray-100 rounded-full p-2" title="Copy">
    <i class='bx bx-copy text-xl'></i>
  </button>

  <button *ngIf="mask" (click)="eye_clicked()" class="text-blue-500 text-sm absolute right-4 top-3">
    <i class='bx bx-show text-xl'></i>
  </button>
</div>

<div *ngIf="control && control.errors && (control.dirty || control.touched)" class="ml-3 mt-1">
  <p class="text-red-500" *ngIf="control.errors.required">{{label}} is required.</p>
  <p class="text-red-500" *ngIf="control.errors.minlength">Minimum length required is {{ control.errors.minlength.requiredLength }}.</p>
  <p class="text-red-500" *ngIf="control.errors.maxlength">Maximum length allowed is {{ control.errors.maxlength.requiredLength }}.</p>
  <p class="text-red-500" *ngIf="control.errors.pattern">Please enter a valid {{label}} value</p>
  <p class="text-red-500" *ngIf="control.errors['email']"> Invalid email format.</p>
  <p class="text-red-500" *ngIf="control.errors['zeroTime']">{{label}} cannot be 00:00:00.</p>
</div>